export default {
  sales: [],
  pagination: {
    links: {},
    meta: {}
  },
  selectedSales: []
}
